module.exports = __webpack_public_path__ + "static/3-1830354b9f88f074c1de956459e4de1d.jpg";